import React from 'react';
import LearnMore from './LearnMore';
import teslaTop from '../../../images/teslaTop.png';

const WhyDrive = ({ isVisible }) => (
  <div className="landing__section grey-background">
    <div className="container section-1__why-drive">
      <div className="section-1__why-drive--left">
        <h2 className="section-1__header section-1__header--sub section-1__header--sub">
          Why Autzu?
        </h2>
        <div className="section-1__reasons-container">
          <div className="section-1__reasons-singlecenter">
            <h4 className="section-1__header section-1__header--medium">
              Sustainability
            </h4>
            <p className="section-1__text section-1__text--blurb section-1__text--margin-right">
              Enjoy the freedom to earn sustainably using electric
              vehicles, with no financial commitments.
            </p>
          </div>
          <div className="section-1__reasons-singlecenter">
            <h4 className="section-1__header section-1__header--medium">
              Flexibility
            </h4>
            <p className="section-1__text section-1__text--blurb section-1__text--margin-right">
              Choose from hourly or daily rentals and only pay two hours
              before your booking.
            </p>
          </div>
          <div className="section-1__reasons-singlecenter">
            <h4 className="section-1__header  section-1__header--medium">
              All inclusive
            </h4>
            <p className="section-1__text section-1__text--blurb">
              Drive hassle-free with vehicle maintenance, insurance, and
              24/7 support provided by Autzu.
            </p>
          </div>
        </div>
        <LearnMore to="/download" text="Download the app" />
      </div>

      <div className="section-1__why-drive--right">
        <div className="section-1__bmw-container">
          <img
            className="section-1__image section-1__image--bmw-top"
            src={teslaTop}
          />
        </div>
      </div>
    </div>
  </div>
);

export default WhyDrive;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageNYC/WhyDrive.js